import { hideVisually, rem } from 'polished';
import styled from 'styled-components';

import { IStyledWrapperProps } from './Tabs.types';

export const StyledNav = styled.nav`
  display: flex;
  flex-direction: row;
  font-size: ${rem('20px')};
  line-height: 1.4;
  font-weight: 600;
`;

export const StyledButton = styled.button`
  padding: ${({ theme }) => rem(theme.spacings.xs)} 0;
  color: ${({ theme }) => theme.colors.cross.grayson};
  background-color: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  border-radius: 0;
  appearance: none;
  cursor: pointer;

  &:not(:first-child) {
    margin-left: ${rem('40px')};
  }

  &:hover {
    color: ${({ theme }) => theme.colors.cross.deepBlu};
  }

  &:focus {
    outline: none; //TODO add proper focus style
  }

  &[aria-selected='true'] {
    cursor: default;
  }
`;

export const StyledPanelGroup = styled.div`
  margin-top: ${({ theme }) => rem(theme.spacings.m)};
`;

export const StyledPanel = styled.div`
  &[aria-hidden='true'] {
    ${hideVisually()};
  }
`;

export const StyledWrapper = styled.div<IStyledWrapperProps>`
  ${StyledButton} {
    &[aria-selected='true'] {
      color: ${({ theme, user }) => user && theme.colors[user].main};
      border-bottom-color: ${({ theme, user }) =>
        user && theme.colors[user].main};
    }
  }
`;
